<div class="fui-layout-pad-content">
  @if (!lesson) {
    <div class="d-flex align-items-center">
      <fui-heading level="5" [text]="title"></fui-heading>
      <span class="pill trans sm m-l-10">{{ videos.length }} Videos</span>
    </div>
    @if (description) {
      <span class="folder-description" [innerHTML]="description | safe: 'html'"></span>
    }
  }
  @if (lesson) {
    <div class="fui-lesson-header m-b-30">
      <div class="lesson-image-container m-r-10" [ngStyle]="{ 'background-image': 'url(' + lesson.image + ')' }"></div>
      <div>
        <div class="d-flex align-items-center">
          <fui-heading level="5" [text]="lesson.title"></fui-heading>
          <span class="pill trans sm m-l-10 text-nowrap">{{ lesson.videos.length }} Videos</span>
          @if (lesson.runtime) {
            <span class="pill trans sm m-l-10 text-nowrap">{{ helperService.hhmmss(lesson.runtime, true) }}</span>
          }
        </div>
        @if (lesson.description) {
          <span class="folder-description" [innerHTML]="lesson.description | safe: 'html'"></span>
        }
        <div class="m-t-10">
          <button class="fui-action-btn sm m-r-10" (click)="toggleSaveLesson(lesson)">
            <fa-icon
              [animation]="togglingAddLessonToLibrary ? 'spin' : undefined"
              [icon]="togglingAddLessonToLibrary ? 'spinner' : contentService.userLearnData.lessons[lesson.id]?.enrolled ? 'minus' : 'plus'"
            ></fa-icon>
            {{ contentService.userLearnData.lessons[lesson.id]?.enrolled ? "Remove from My Library" : "Add to My Library" }}
          </button>
          <button class="fui-action-btn sm m-r-10" (click)="copyLink(lesson)">
            <fa-icon [icon]="copied ? 'check' : 'link'"></fa-icon>
            {{ copied ? "Copied!" : "Copy Link" }}
          </button>
          <button class="fui-action-btn sm" [routerLink]="['/learn/lesson/', lesson.id]">
            View Lesson
            <fa-icon icon="chevron-right"></fa-icon>
          </button>
        </div>
      </div>
    </div>
  }
</div>
<div class="fui-layout-edge-content">
  <ul class="learn-list-horizontal-scroll video-grid" [class.no-left-margin]="!leftMargin" preventHorizontalNav dragToScroll>
    @for (video of videos | slice: 0 : 10; track video) {
      <li>
        <myp-video-grid-item [video]="video"></myp-video-grid-item>
      </li>
    }
    @if (videos.length > 10) {
      <li class="show-more-button">
        <div class="text-center">
          <button class="fui-action-btn" (click)="this.showMoreVideos.emit(folder)">
            Show More Videos
            <fa-icon icon="chevron-right" class="m-l-5"></fa-icon>
          </button>
          <div class="text-muted m-t-10">{{ videos.length }} Total Videos</div>
        </div>
      </li>
    }
  </ul>
</div>
